"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ModalFooter["default"];
  }
});
var _ModalFooter = _interopRequireDefault(require("react-bootstrap/lib/ModalFooter"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/ModalFooter.js
// module id = 6406
// module chunks = 25